import { bootstrapOrganizationContext, type BootstrapOrganizationContextResult } from './sync';
import { getSessionFromAuth0, type Auth0SessionTokens } from '../auth0/session-token-loader';
import type {
  Auth0ClientLike,
  AuthSessionFlowTrace,
  AuthSessionStatus,
  EnsureSessionOptions,
  UserContextStoreLike,
} from '../session/types';

type BootstrapOrganizationContextInput = {
  auth0Client: Auth0ClientLike;
  currentOrganizationId: string | null;
  options?: EnsureSessionOptions;
  userContextStore: UserContextStoreLike;
  trace: AuthSessionFlowTrace;
  setStatus: (nextStatus: AuthSessionStatus, error?: unknown) => void;
  setSession: (session: { accessToken: string; nextIdToken: string }) => void;
};

export const coordinateOrganizationSession = (
  loadOrganizationSession: (request: {
    auth0Client: Auth0ClientLike;
    freshAuth0Token?: boolean;
    organization?: string | null;
    timeoutMs?: number;
  }) => Promise<Auth0SessionTokens>,
  input: BootstrapOrganizationContextInput,
): Promise<BootstrapOrganizationContextResult> => {
  return bootstrapOrganizationContext({
    ...input,
    loadOrganizationSession,
  });
};

export type OrganizationCoordinator = {
  coordinateOrganizationSession: (
    input: BootstrapOrganizationContextInput,
  ) => Promise<BootstrapOrganizationContextResult>;
};

export const createOrganizationCoordinator = () => {
  const loadOrganizationSession = getSessionFromAuth0;

  return {
    coordinateOrganizationSession: (input: BootstrapOrganizationContextInput) => {
      return coordinateOrganizationSession(loadOrganizationSession, input);
    },
  };
};
